import { Directive, Input } from '@angular/core';

import { Subject } from 'rxjs';

import { Cell } from './table-cell.entity';

@Directive()
export abstract class ShBaseCell {
    @Input() public abstract cell: Cell;
    protected destroy$: Subject<void> = new Subject<void>();
}
